<template>
  <div class="d-flex align-items-center">
    <span class="font-weight-bold mr-2">{{ value }}/{{ maxValue }}</span>
    <div class="scale-bars d-flex">
      <div v-for="i in maxValue" :key="i" class="scale-bar" :class="{ filled: i <= value }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScaleIndicator",

  props: {
    value: {
      type: Number,
      required: true,
    },
    maxValue: {
      type: Number,
      default: 5,
    },
  },
};
</script>

<style lang="scss" scoped>
.scale-bars {
  gap: 2px;
}

.scale-bar {
  width: 20px;
  height: 6px;
  border-radius: 2px;
  background-color: #dee2e6;

  &.filled {
    background-color: black;
  }
}
</style>
